<template lang="pug">
    el-dialog(title="查看详情",width="95%", :close-on-click-modal='false', :append-to-body="true" :visible.sync='visible' :modal-append-to-body='false'  @closed="reset")
      el-form(:model='dataForm', ref='dataForm', label-suffix=":" label-width="auto" )
        el-form-item(label='标题')
            span() {{dataForm.title}}
        el-form-item(label='类型')
            span() {{dataForm.type}}
        el-form-item(label="LOGO")
            img(v-if="dataForm.logo" :src="dataForm.logo" class="avatar")
            img(v-else src="../../mb/img/img.jpg" class="avatar")
        el-form-item(label='LOGO排序号')
            span() {{dataForm.logo_sort}}
        el-form-item(label='关联主办方')
            span() {{dataForm.orgName?dataForm.orgName:'无'}}
        el-form-item(label='简介')
            span() {{dataForm.intro?dataForm.intro:'无'}}
        el-form-item(label='是否启用')
            span() {{dataForm.enable}}
      span.dialog-footer(slot='footer')
        el-button(@click='visible = false') 返回
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        title: null,
        type: null,
        logo: null,
        logo_sort: null,
        orgName: null,
        intro: null,
        enable: false
      }
    };
  },
  methods: {
    init (rows) {
      let { title, type, logoUrl, logoSort, intro, status, orgName } = rows;
      this.visible = true;
      this.dataForm = {
        title,
        type: type === 0 ? '战略合作伙伴' : type === 1 ? '赞助商' : '供应商',
        logo: logoUrl,
        logo_sort: logoSort,
        orgName,
        intro,
        enable: status === 0 ? '停用' : '启用'
      };
      console.log(this.dataForm.logoUrl)
    },
    reset () {
      this.dataForm = {};
    }
  }
};
</script>
<style lang="scss" scoped>
.avatar {
  width: 240px;
  height: 174px;
  display: block;
}
</style>
